module.exports = __webpack_public_path__ + "assets/favicon-bf-nl.ec0a3fb1.png";